// prettier-ignore
import Vue from "vue";
import config from "@/config";
import { initializeApp } from "firebase/app";
import {
  collection,
  query,
  where,
  onSnapshot,
  getFirestore,
  //setDoc,
  //doc
} from "firebase/firestore";

const fApp = initializeApp(config.firebase);
const db = getFirestore(fApp);

connectToServer();

let unsync,unsync2;
async function connectToServer() {
  let start = new Date();
  start.setUTCHours(0, 0, 0, 0);
  if (unsync) unsync();
  const q = query(collection(db, config.firebase.col), where("updated", ">=", start), where("customer", "==", 'person/0624854494')); //
  unsync = onSnapshot(q, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      let doc = change.doc.data();
      doc.id = change.doc.id.toString();
      Vue.prototype.$events.$emit('order_' +change.type, doc);
    });
  });
  if (unsync2) unsync2();
  const q2 = query(collection(db, config.firebase.col), where("updated", ">=", start), where("courier", "==", 'person/0624854494')); //
  unsync2 = onSnapshot(q2, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      let doc = change.doc.data();
      doc.id = change.doc.id.toString();
      //console.log('courier_' + change.type, doc)
      Vue.prototype.$events.$emit('courier_' + change.type, doc);
    });
  });
}